import { lazy } from 'react';

export const ClientsPageAsync = lazy(() => import('./ClientsPage'));
